const replacementMap = {
    a: 'z', b: 'y', c: 'x', d: 'w', e: 'v', f: 'u',
    g: 't', h: 's', i: 'r', j: 'q', k: 'p', l: 'o',
    m: 'n', n: 'm', o: 'l', p: 'k', q: 'j', r: 'i',
    s: 'h', t: 'g', u: 'f', v: 'e', w: 'd', x: 'c',
    y: 'b', z: 'a', 0: '9', 1: '8', 2: '7', 3: '6', 4: '5', 5: '4', 6: '3', 7: '2', 8: '1', 9: '0'
  };

  export const encrypt = (realID) => {
    let reversed = realID.split('').reverse().join('');

    let transformed = reversed.split('').map(char => replacementMap[char] || char).join('');
    
    return transformed;
  };


  export const decrypt = (pseudoID) => {
    let reversed = pseudoID.split('').reverse().join('');

    let realID = reversed.split('').map(char => {
      const originalChar = Object.keys(replacementMap).find(key => replacementMap[key] === char);
      return originalChar || char;
    }).join('');
    
    return realID;
  };
  